import {Button, Table} from "antd";
import moment from "moment";
import React, {useState, useEffect} from "react";
import stores from "../../../../store/stores";
import {useFetch} from "../../../../hooks/useFetch";
import ShipmentActivitiesTable from "../shipmentActivitiesTable/ShipmentActivitiesTable";

const TransferActivitiesTable = ({
    shipmentTransferGroups,
    shipmentTransferGroupsLoading,
    setPage
}) => {
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [shipmentData, setShipmentData] = useState({});
    const [shipmentPages, setShipmentPages] = useState({});
    const [loading, setLoading] = useState({});
    const [fetchParams, setFetchParams] = useState({groupId: null, page: 1});

    useEffect(() => {
        setExpandedRowKeys([]);
    }, [shipmentTransferGroups?.pagination?.page]);

    const [transferGroupShipmentLoading] = useFetch({
        fetchFn: () => {
            if (!fetchParams.groupId) return Promise.resolve(null);

            const urlSearchParams = new URLSearchParams(window.location.search);

            // URL'den parametreleri al
            const urlShipmentNumber = urlSearchParams.get("shipmentNumber");
            const urlWarehouseStatus = urlSearchParams.get("warehouseStatus");
            const urlDeliveryStatus = urlSearchParams.get("deliveryStatus");
            const urlMissingStatus = urlSearchParams.get("missingStatus");

            return stores.transferStore.transferGroupShipmentList({
                groupId: fetchParams.groupId,
                page: fetchParams.page,
                limit: 10,
                ...(urlShipmentNumber && {shipmentNumber: urlShipmentNumber}),
                ...(urlWarehouseStatus && {warehouseStatus: urlWarehouseStatus}),
                ...(urlDeliveryStatus && {deliveryStatus: urlDeliveryStatus}),
                ...(urlMissingStatus && {missingStatus: urlMissingStatus})
            });
        },
        dependencies: [fetchParams],
        showLoading: true,
        initialCall: false,
        enabled: !!fetchParams.groupId,
        callbackFunc: response => {
            if (!response || !fetchParams.groupId) return;

            setShipmentData(prev => ({
                ...prev,
                [fetchParams.groupId]: response?.data || []
            }));

            setShipmentPages(prev => ({
                ...prev,
                [fetchParams.groupId]: {
                    current: fetchParams.page,
                    total: response?.pagination?.total,
                    limit: response?.pagination?.limit
                }
            }));

            setLoading(prev => ({...prev, [fetchParams.groupId]: false}));
        }
    });

    const fetchShipmentData = (groupId, page = 1) => {
        setLoading(prev => ({...prev, [groupId]: true}));
        setFetchParams({groupId, page});
    };

    return (
        <div className="waiting-transfer-page">
            <Table
                dataSource={shipmentTransferGroups?.data}
                loading={shipmentTransferGroupsLoading}
                rowKey={record => record._id}
                pagination={{
                    current: shipmentTransferGroups?.pagination?.page,
                    pageSize: shipmentTransferGroups?.pagination?.limit,
                    total: shipmentTransferGroups?.pagination?.total,
                    onChange: page => {
                        setPage(page);
                    }
                }}
                className="group-table"
                scroll={{x: 1000}}
                expandable={{
                    expandedRowKeys: expandedRowKeys,
                    onExpand: (expanded, record) => {
                        if (expanded) {
                            setExpandedRowKeys(prev => [...prev, record._id]);
                            fetchShipmentData(record._id, 1);
                        } else {
                            setExpandedRowKeys(prev => prev.filter(key => key !== record._id));
                        }
                    },
                    expandedRowRender: record => {
                        return (
                            <ShipmentActivitiesTable
                                selectedShipmentData={{
                                    shipments: shipmentData[record._id] || [],
                                    pagination: shipmentPages[record._id] || {
                                        current: 1,
                                        limit: 10,
                                        total: 0
                                    }
                                }}
                                transferGroupShipmentLoading={loading[record._id] || false}
                                page={shipmentPages[record._id]?.current || 1}
                                setPage={newPage => fetchShipmentData(record._id, newPage)}
                            />
                        );
                    }
                }}
            >
                <Table.Column
                    title="Gün"
                    dataIndex="date"
                    key="date"
                    render={date => moment(date).format("DD-MM-YYYY")}
                />
                <Table.Column title="Transfer Grubu" dataIndex="name" key="name" />
                <Table.Column
                    title="Cutoff Başlangıç Tarihi"
                    dataIndex="cutOffStartDate"
                    key="cutOffStartDate"
                    render={cutOffStartDate => moment(cutOffStartDate).format("DD-MM-YYYY HH:mm")}
                />
                <Table.Column
                    title="Cutoff Bitiş Tarihi"
                    dataIndex="cutOffEndDate"
                    key="cutOffEndDate"
                    render={cutOffEndDate => moment(cutOffEndDate).format("DD-MM-YYYY HH:mm")}
                />
                <Table.Column
                    title="Nereden"
                    dataIndex="from"
                    key="from"
                    render={from => from.name}
                />
                <Table.Column title="Nereye" dataIndex="to" key="to" render={to => to.name} />
                <Table.Column
                    title="Grup Durumu"
                    dataIndex="status"
                    key="status"
                    render={status =>
                        status === "completed"
                            ? "Tamamlandı"
                            : status === "closed"
                            ? "Gün Kapandı"
                            : status === "pending"
                            ? "Beklemede"
                            : status === "created"
                            ? "Oluşturuldu"
                            : "-"
                    }
                />
            </Table>
        </div>
    );
};

export default TransferActivitiesTable;
